import { acrMonitorColors } from "./colors";
import { Box, FormControl, InputLabel, TextField } from "@mui/material";
import { createTheme, adaptV4Theme } from "@mui/material/styles";

import { styled } from "@mui/system";

export const theme = createTheme({
  palette: {
    primary: {
      main: acrMonitorColors.PRIMARY_MAIN,
      dark: acrMonitorColors.PRIMARY_DARK,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      main: acrMonitorColors.SECONDARY_MAIN,
      dark: acrMonitorColors.SECONDARY_DARK,
    },
  },
  typography: {
    body1: {
      fontSize: "12px",
    },
    h3: {
      fontSize: "32px",
    },
    h4: {
      fontSize: "18px",
    },
    h5: {
      fontSize: "16px",
    },
    h6: {
      fontSize: "14px",
      color: "#555",
    },
    fontFamily: [
      "Arial",
      "Roboto",
      '"Helvetica Neue"',
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  components: {
    MuiTable: {
      styleOverrides: {
        root: {},
      }
    },
    MuiTableCell: {
      styleOverrides: {
      root: {
        padding: "5px",
      },
    }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: "0.75em",
          height: "0.75em",
        },
      }
    },
    MuiAppBar: {
      styleOverrides: {
      root: {
        fontSize: "14px",
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        textTransform: "uppercase",
      },
      positionStatic: {
        height: "48px",
      },
      }
    },
    MuiTab: {
      styleOverrides: {
      root: {
        minWidth: "60px",
        paddinTop: "0",
      },
    }
    },
    MuiTabs: {
      styleOverrides: {
      root: {
        minWidth: "70px",
        overflow: "unset",
      },
      fixed: {
        overflow: "unset!important" as any,
      },
      }
    },
    MuiSnackbar: {
      styleOverrides: {
      root: {},
      }
    },
    MuiSnackbarContent: {
      styleOverrides: {
      root: {},
      message: {},
      }
    },
    // MuiInputLabel: {
    //   styleOverrides: {
    //   root: { transform: "translate(0, 1.5px) scale(1)" },
    //   outlined: { transform: "translate(14px, 15px) scale(1)" },
    //   }
    // },
    MuiOutlinedInput: {
      styleOverrides: {
      input: { padding: "12.5px 14px" },
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
      contained: { color: "#f44336" },
      root: {
        fontSize:".75em"
      },
    }
    },
  },
});


export const MyBoxContainer = styled(Box)(({}) => ({
  margin: "0 8px 8px 8px",
  padding: "0 8px 8px 8px",
}));

export const MyTextField = styled(TextField)(({}) => ({
  fontSize: "11px",
  textAlign: "center",
  width: "100%",
}));

export const MyInputMiniLabel = styled(InputLabel)(({}) => ({
  fontSize: "14px !important",
  textAlign: "center",
  width: "100%",
  margin: "2px",
}));

export const MyFormControl = styled(FormControl)(({}) => ({
  width: "7.3rem"
}));
